import { type DeliveryByEvent, deliveryByEventNames } from '@noths/polaris-client-utils';

export const isDeliveryAvailableByEvent = (
  deliveryEventIsAvailableForZone: boolean,
  productDeliveryByEvent: DeliveryByEvent | null,
) =>
  Boolean(
    deliveryEventIsAvailableForZone &&
      productDeliveryByEvent?.arriveByEvent &&
      deliveryByEventNames.includes(productDeliveryByEvent?.eventName),
  );
